import {makeStyles} from '@material-ui/core'


export const useStyles = makeStyles({
  
   
    heading:{
        width:"75%",
        height:"125%",
        objectFit:"cover",
        position:"absolute",
        zIndex:"-1",
        
    },
    headingDiv:{
        // marginTop:"5%",
        marginBottom:"2%",
        position:"relative",
        backgroundColor:"#D9D9D9",
        width:"100%",
        borderRadius: "16px",

    },
    headingText:{
        color:"black",
        fontSize:"2.5vw",
        marginLeft:"7%",
        pointerEvents:'none',
        fontWeight:350
    },
    
    socials:{
        color:"black",
        fontSize:"7vh",
        fontWeight:"200",
        marginTop:"5%",
        width:"25%",
        
        backgroundColor:"#D9D9D9",
        paddingTop:"1.5%",
        paddingBottom:"1.5%",
        paddingLeft:"7%",
        paddingRight:"7%",
        borderRadius: "16px",
        fontFamily:'Edu NSW ACT Foundation'
        
    },
    socialsBody : {
        fontFamily:'IBM Plex Sans',
        fontSize:"3vh",
        marginTop:"0%",
        marginBottom:"1%"
    },
    linkless : {
        color: "black",
        textDecorationStyle:"none",
        textDecoration: "none"
    }
})

